/**
 * Prefecture enum
 */
export enum Prefecture {
  HOKKAIDO = 1,
  AOMORI = 2,
  IWATE = 3,
  MIYAGI = 4,
  AKITA = 5,
  YAMAGATA = 6,
  FUKUSHIMA = 7,
  IBARAKI = 8,
  TOCHIGI = 9,
  GUNMA = 10,
  SAITAMA = 11,
  CHIBA = 12,
  TOKYO = 13,
  KANAGAWA = 14,
  NIIGATA = 15,
  TOYAMA = 16,
  ISHIKAWA = 17,
  FUKUI = 18,
  YAMANASHI = 19,
  NAGANO = 20,
  GIFU = 21,
  SHIZUOKA = 22,
  AICHI = 23,
  MIE = 24,
  SHIGA = 25,
  KYOTO = 26,
  OSAKA = 27,
  HYOGO = 28,
  NARA = 29,
  WAKAYAMA = 30,
  TOTTORI = 31,
  SHIMANE = 32,
  OKAYAMA = 33,
  HIROSHIMA = 34,
  YAMAGUCHI = 35,
  TOKUSHIMA = 36,
  KAGAWA = 37,
  EHIME = 38,
  KOCHI = 39,
  FUKUOKA = 40,
  SAGA = 41,
  NAGASAKI = 42,
  KUMAMOTO = 43,
  OITA = 44,
  MIYAZAKI = 45,
  KAGOSHIMA = 46,
  OKINAWA = 47,
}

/**
 * Prefectures list
 */
export const prefectures = [
  { id: Prefecture.HOKKAIDO, name: '北海道', slug: 'hokkaido' },
  { id: Prefecture.AOMORI, name: '青森県', slug: 'aomori' },
  { id: Prefecture.IWATE, name: '岩手県', slug: 'iwate' },
  { id: Prefecture.MIYAGI, name: '宮城県', slug: 'miyagi' },
  { id: Prefecture.AKITA, name: '秋田県', slug: 'akita' },
  { id: Prefecture.YAMAGATA, name: '山形県', slug: 'yamagata' },
  { id: Prefecture.FUKUSHIMA, name: '福島県', slug: 'fukushima' },
  { id: Prefecture.IBARAKI, name: '茨城県', slug: 'ibaraki' },
  { id: Prefecture.TOCHIGI, name: '栃木県', slug: 'tochigi' },
  { id: Prefecture.GUNMA, name: '群馬県', slug: 'gunma' },
  { id: Prefecture.SAITAMA, name: '埼玉県', slug: 'saitama' },
  { id: Prefecture.CHIBA, name: '千葉県', slug: 'chiba' },
  { id: Prefecture.TOKYO, name: '東京都', slug: 'tokyo' },
  { id: Prefecture.KANAGAWA, name: '神奈川県', slug: 'kanagawa' },
  { id: Prefecture.NIIGATA, name: '新潟県', slug: 'niigata' },
  { id: Prefecture.TOYAMA, name: '富山県', slug: 'toyama' },
  { id: Prefecture.ISHIKAWA, name: '石川県', slug: 'ishikawa' },
  { id: Prefecture.FUKUI, name: '福井県', slug: 'fukui' },
  { id: Prefecture.YAMANASHI, name: '山梨県', slug: 'yamanashi' },
  { id: Prefecture.NAGANO, name: '長野県', slug: 'nagano' },
  { id: Prefecture.GIFU, name: '岐阜県', slug: 'gifu' },
  { id: Prefecture.SHIZUOKA, name: '静岡県', slug: 'shizuoka' },
  { id: Prefecture.AICHI, name: '愛知県', slug: 'aichi' },
  { id: Prefecture.MIE, name: '三重県', slug: 'mie' },
  { id: Prefecture.SHIGA, name: '滋賀県', slug: 'shiga' },
  { id: Prefecture.KYOTO, name: '京都府', slug: 'kyoto' },
  { id: Prefecture.OSAKA, name: '大阪府', slug: 'osaka' },
  { id: Prefecture.HYOGO, name: '兵庫県', slug: 'hyogo' },
  { id: Prefecture.NARA, name: '奈良県', slug: 'nara' },
  { id: Prefecture.WAKAYAMA, name: '和歌山県', slug: 'wakayama' },
  { id: Prefecture.TOTTORI, name: '鳥取県', slug: 'tottori' },
  { id: Prefecture.SHIMANE, name: '島根県', slug: 'shimane' },
  { id: Prefecture.OKAYAMA, name: '岡山県', slug: 'okayama' },
  { id: Prefecture.HIROSHIMA, name: '広島県', slug: 'hiroshima' },
  { id: Prefecture.YAMAGUCHI, name: '山口県', slug: 'yamaguchi' },
  { id: Prefecture.TOKUSHIMA, name: '徳島県', slug: 'tokushima' },
  { id: Prefecture.KAGAWA, name: '香川県', slug: 'kagawa' },
  { id: Prefecture.EHIME, name: '愛媛県', slug: 'ehime' },
  { id: Prefecture.KOCHI, name: '高知県', slug: 'kochi' },
  { id: Prefecture.FUKUOKA, name: '福岡県', slug: 'fukuoka' },
  { id: Prefecture.SAGA, name: '佐賀県', slug: 'saga' },
  { id: Prefecture.NAGASAKI, name: '長崎県', slug: 'nagasaki' },
  { id: Prefecture.KUMAMOTO, name: '熊本県', slug: 'kumamoto' },
  { id: Prefecture.OITA, name: '大分県', slug: 'oita' },
  { id: Prefecture.MIYAZAKI, name: '宮崎県', slug: 'miyazaki' },
  { id: Prefecture.KAGOSHIMA, name: '鹿児島県', slug: 'kagoshima' },
  { id: Prefecture.OKINAWA, name: '沖縄県', slug: 'okinawa' },
] as const

export const prefectureSlugs = prefectures.map(
  (prefecture) => prefecture.slug,
) as (typeof prefectures)[number]['slug'][]
